export { default } from './ColorScalePicker';
